"use strict";
exports.__esModule = true;
function removeExtraSpaces(value) {
    return value.replace(/  +/g, " ").trim();
}
exports["default"] = removeExtraSpaces;
